(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[83459],{

/***/ 73700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(6264);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14671);
/* harmony import */ var global_SEO__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26350);
/* harmony import */ var hooks_usePublicProtectedRoute__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80288);
/* harmony import */ var lib_stores_trading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76260);
/* harmony import */ var global_MainLayout_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73580);
/* harmony import */ var react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50259);
/* harmony import */ var features_trusted_device_store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91164);

__webpack_require__(14473);









var captchaSiteKey = "6LeBXZYqAAAAAIAqBYdAV5HuBc6i0YeVziSYrXAZ";
var AuthLayout = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 25900).then(__webpack_require__.bind(__webpack_require__, 25900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25900)
            ];
        }
    }
});
var Login = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(23304), __webpack_require__.e(51767), __webpack_require__.e(85145), __webpack_require__.e(2880)]).then(__webpack_require__.bind(__webpack_require__, 2880));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2880)
            ];
        }
    }
});
var useTradingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(lib_stores_trading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
var useMainLayoutStore = (0,zustand__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(global_MainLayout_store__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
function LoginPage() {
    (0,hooks_usePublicProtectedRoute__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var ref = (0,features_trusted_device_store__WEBPACK_IMPORTED_MODULE_8__/* .useTrustedDeviceStore */ .u)(function(s) {
        return {
            resetLoginType: s.resetLoginType,
            resetTrustedDevice: s.resetTrustedDevice,
            resetNewDeviceOTPConfig: s.resetNewDeviceOTPConfig
        };
    }), resetNewDeviceOTPConfig = ref.resetNewDeviceOTPConfig, resetTrustedDevice = ref.resetTrustedDevice, resetLoginType = ref.resetLoginType;
    var ref1 = useTradingStore(function(s) {
        return {
            errorCodeSecurities: s.errorCode,
            resetErrorCodeSecurities: s.resetErrorCode
        };
    }), errorCodeSecurities = ref1.errorCodeSecurities, resetErrorCodeSecurities = ref1.resetErrorCodeSecurities;
    var ref2 = useMainLayoutStore(function(s) {
        return {
            errorCodeSocial: s.errorCode,
            resetErrorCodeSocial: s.resetErrorCode
        };
    }), errorCodeSocial = ref2.errorCodeSocial, resetErrorCodeSocial = ref2.resetErrorCodeSocial;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        resetErrorCodeSocial();
        resetErrorCodeSecurities();
    }, [
        errorCodeSecurities,
        errorCodeSocial
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        resetNewDeviceOTPConfig();
        resetTrustedDevice();
        resetLoginType();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AuthLayout, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_SEO__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                description: "Login ke aplikasi Stockbit. Bisa dengan Google, Facebook atau Email."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha_v3__WEBPACK_IMPORTED_MODULE_7__/* .GoogleReCaptchaProvider */ .pm, {
                reCaptchaKey: captchaSiteKey,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Login, {})
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (LoginPage);


/***/ }),

/***/ 99055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LoginType; }
/* harmony export */ });
var LoginType;
(function(LoginType) {
    LoginType["LOGIN_DATA_TYPE_UNSPECIFIED"] = "LOGIN_DATA_TYPE_UNSPECIFIED";
    LoginType["LOGIN_DATA_TYPE_SUCCESS"] = "LOGIN_DATA_TYPE_SUCCESS";
    LoginType["LOGIN_DATA_TYPE_NEW_DEVICE"] = "LOGIN_DATA_TYPE_NEW_DEVICE";
    LoginType["LOGIN_DATA_TYPE_TRUSTED_DEVICE"] = "LOGIN_DATA_TYPE_TRUSTED_DEVICE";
})(LoginType || (LoginType = {}));


/***/ }),

/***/ 91164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ useTrustedDeviceStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware/immer.js
var immer = __webpack_require__(42435);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/lib/store.ts + 33 modules
var store = __webpack_require__(61805);
// EXTERNAL MODULE: ./src/features/login/types.ts
var types = __webpack_require__(99055);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/lib/api/trustedDevice.ts


var request = exodus/* default.withLanguageInstance */.Z.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.ENGLISH */.$6.ENGLISH, true);
var requestWithoutAlert = exodus/* default.withLanguageInstance */.Z.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.ENGLISH */.$6.ENGLISH, false);
var requestOtpNewDevice = function(param) {
    var token = param.token, channel = param.channel;
    return request.post("/login/v3/new-device/otp", {
        token: token,
        channel: channel
    });
};
var verifyOtpNewDevice = function(param) {
    var token = param.token, otp = param.otp;
    return requestWithoutAlert.post("/login/v3/new-device/otp/verify", {
        token: token,
        otp: otp
    });
};
var requestVerifyIdentity = function(param) {
    var token = param.token, identity = param.identity, birthDate = param.birthDate, bankAccountNumber = param.bankAccountNumber, motherName = param.motherName;
    return requestWithoutAlert.post("login/v4/recovery/identity/validate", {
        token: token,
        identity: identity,
        birth_date: birthDate,
        bank_account_number: bankAccountNumber,
        mother_name: motherName
    });
};
var requestVerifyPassword = function(param) {
    var token = param.token, password = param.password;
    return request.post("login/v4/recovery/password/validate", {
        token: token,
        password: password
    });
};
var requestVerifyPin = function(param) {
    var token = param.token, pin = param.pin;
    return request.post("login/v4/recovery/pin/validate", {
        token: token,
        pin: pin
    });
};
var requestOtpTrustedDevice = function(param) {
    var token = param.token, channel = param.channel;
    return request.post("login/v4/recovery/otp", {
        token: token,
        channel: channel
    });
};
var verifyOtpTrustedDevice = function(param) {
    var token = param.token, otp = param.otp;
    return requestWithoutAlert.post("login/v4/recovery/otp/verify", {
        token: token,
        otp: otp
    });
};
var requestSendPrompt = function(param) {
    var token = param.token;
    return requestWithoutAlert.post("login/v4/new-device/prompt/send", {
        token: token
    });
};
var getPromptResult = function(token) {
    return requestWithoutAlert.get("mfa/v1/prompt/verified/result", {
        params: {
            token: token
        }
    });
};
var verifyPromptRequest = function(param) {
    var token = param.token, acknowledgeToken = param.acknowledgeToken;
    return requestWithoutAlert.post("login/v4/new-device/prompt/verify", {
        token: token,
        acknowledge_token: acknowledgeToken
    });
};
var requestForgotPin = function(param) {
    var token = param.token;
    return request.post("login/v4/recovery/pin/forgot", {
        token: token
    });
};

// EXTERNAL MODULE: ./src/features/trusted-device/types.ts
var trusted_device_types = __webpack_require__(81945);
// EXTERNAL MODULE: ./src/features/trusted-device/utils.ts
var utils = __webpack_require__(721);
// EXTERNAL MODULE: ./src/features/trusted-device/tracker.ts + 1 modules
var tracker = __webpack_require__(33597);
;// CONCATENATED MODULE: ./src/features/trusted-device/store.ts















var initialState = {
    loginType: types/* LoginType.LOGIN_DATA_TYPE_UNSPECIFIED */.B.LOGIN_DATA_TYPE_UNSPECIFIED,
    newDeviceOTPConfig: {
        token: "",
        /// OTP Section ///
        otpRecipients: [],
        channel: trusted_device_types/* CHANNEL_OTP.EMAIL */.U.EMAIL,
        otp: "",
        target: "",
        remainingSecond: 0,
        /// ----------- ///
        /// API Call State ///
        isSubmitting: false,
        errorText: ""
    },
    trustedDevice: {
        token: "",
        deviceName: "",
        /// Prompt Section ///
        promptToken: "",
        promptRemainingSecond: 0,
        promptTarget: "",
        promptStatus: trusted_device_types/* PROMPT_STATUS.PROMPT_STATUS_UNSPECIFIED */.g.PROMPT_STATUS_UNSPECIFIED,
        ackPrompToken: "",
        /// ----------- ///
        /// OTP Section ///
        otpRecipients: [],
        channel: trusted_device_types/* CHANNEL_OTP.EMAIL */.U.EMAIL,
        otp: "",
        target: "",
        remainingSecond: 0,
        /// ----------- ///
        /// API Call State ///
        isSubmitting: false,
        errorText: "",
        errors: []
    }
};
var useTrustedDeviceStore = (0,esm/* default */.ZP)()((0,middleware/* persist */.tJ)((0,immer/* immer */.n)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        updateLoginType: function(loginType) {
            return set({
                loginType: loginType
            });
        },
        resetLoginType: function() {
            return set({
                loginType: initialState.loginType
            });
        },
        updateNewDeviceOTPConfig: function(param) {
            var token = param.token, otpRecipients = param.otpRecipients, channel = param.channel, otp = param.otp, target = param.target, remainingSecond = param.remainingSecond, isSubmitting = param.isSubmitting, errorText = param.errorText;
            return set(function(draft) {
                draft.newDeviceOTPConfig.token = token !== null && token !== void 0 ? token : draft.newDeviceOTPConfig.token;
                draft.newDeviceOTPConfig.otpRecipients = otpRecipients !== null && otpRecipients !== void 0 ? otpRecipients : draft.newDeviceOTPConfig.otpRecipients;
                draft.newDeviceOTPConfig.channel = channel !== null && channel !== void 0 ? channel : draft.newDeviceOTPConfig.channel;
                draft.newDeviceOTPConfig.otp = otp !== null && otp !== void 0 ? otp : draft.newDeviceOTPConfig.otp;
                draft.newDeviceOTPConfig.target = target !== null && target !== void 0 ? target : draft.newDeviceOTPConfig.target;
                draft.newDeviceOTPConfig.remainingSecond = remainingSecond !== null && remainingSecond !== void 0 ? remainingSecond : draft.newDeviceOTPConfig.remainingSecond;
                draft.newDeviceOTPConfig.isSubmitting = isSubmitting !== null && isSubmitting !== void 0 ? isSubmitting : draft.newDeviceOTPConfig.isSubmitting;
                draft.newDeviceOTPConfig.errorText = errorText !== null && errorText !== void 0 ? errorText : draft.newDeviceOTPConfig.errorText;
            });
        },
        resetNewDeviceOTPConfig: function() {
            get().updateNewDeviceOTPConfig(initialState.newDeviceOTPConfig);
        },
        requestOtpNewDevice: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, _newDeviceOTPConfig, token, channel, response, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        get().updateNewDeviceOTPConfig({
                            isSubmitting: true,
                            errorText: ""
                        });
                        _newDeviceOTPConfig = get().newDeviceOTPConfig, token = _newDeviceOTPConfig.token, channel = _newDeviceOTPConfig.channel;
                        _ctx.next = 6;
                        return requestOtpNewDevice({
                            token: token,
                            channel: channel
                        });
                    case 6:
                        response = _ctx.sent;
                        get().updateNewDeviceOTPConfig({
                            target: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.target,
                            remainingSecond: (0,utils/* calculateRemainingOtpSecond */.M)(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.next_attempt_time)
                        });
                        _ctx.next = 15;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateNewDeviceOTPConfig({
                            remainingSecond: 0,
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.cause) === null || ref4 === void 0 ? void 0 : ref4.message
                        });
                        // Re-throw error so component can handle
                        throw _ctx.t0;
                    case 15:
                        _ctx.prev = 15;
                        get().updateNewDeviceOTPConfig({
                            isSubmitting: false
                        });
                        return _ctx.finish(15);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    15,
                    18
                ]
            ]);
        })),
        verifyOtpNewDevice: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
                var ref, _newDeviceOTPConfig, token, otp, response, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            get().updateNewDeviceOTPConfig({
                                isSubmitting: true,
                                errorText: ""
                            });
                            _newDeviceOTPConfig = get().newDeviceOTPConfig, token = _newDeviceOTPConfig.token, otp = _newDeviceOTPConfig.otp;
                            _ctx.next = 6;
                            return verifyOtpNewDevice({
                                token: token,
                                otp: otp
                            });
                        case 6:
                            response = _ctx.sent;
                            store/* store.dispatch */.h.dispatch(credentials/* default.actions.loadCredentialsExodus */.ZP.actions.loadCredentialsExodus(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data));
                            (0,tracker/* trackerLoginCompleted */.pO)();
                            cb();
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            get().updateNewDeviceOTPConfig({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                            });
                        case 16:
                            _ctx.prev = 16;
                            get().updateNewDeviceOTPConfig({
                                isSubmitting: false
                            });
                            return _ctx.finish(16);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12,
                        16,
                        19
                    ]
                ]);
            }));
            return function(cb) {
                return _ref.apply(this, arguments);
            };
        }(),
        updateTrustedDevice: function(param) {
            var token = param.token, promptToken = param.promptToken, promptRemainingSecond = param.promptRemainingSecond, promptTarget = param.promptTarget, ackPrompToken = param.ackPrompToken, promptStatus = param.promptStatus, channel = param.channel, deviceName = param.deviceName, otpRecipients = param.otpRecipients, otp = param.otp, target = param.target, remainingSecond = param.remainingSecond, isSubmitting = param.isSubmitting, errorText = param.errorText, errors = param.errors;
            return set(function(draft) {
                draft.trustedDevice.token = token !== null && token !== void 0 ? token : draft.trustedDevice.token;
                draft.trustedDevice.promptToken = promptToken !== null && promptToken !== void 0 ? promptToken : draft.trustedDevice.promptToken;
                draft.trustedDevice.promptRemainingSecond = promptRemainingSecond !== null && promptRemainingSecond !== void 0 ? promptRemainingSecond : draft.trustedDevice.promptRemainingSecond;
                draft.trustedDevice.promptTarget = promptTarget !== null && promptTarget !== void 0 ? promptTarget : draft.trustedDevice.promptTarget;
                draft.trustedDevice.ackPrompToken = ackPrompToken !== null && ackPrompToken !== void 0 ? ackPrompToken : draft.trustedDevice.ackPrompToken;
                draft.trustedDevice.promptStatus = promptStatus !== null && promptStatus !== void 0 ? promptStatus : draft.trustedDevice.promptStatus;
                draft.trustedDevice.deviceName = deviceName !== null && deviceName !== void 0 ? deviceName : draft.trustedDevice.deviceName;
                draft.trustedDevice.otpRecipients = otpRecipients !== null && otpRecipients !== void 0 ? otpRecipients : draft.trustedDevice.otpRecipients;
                draft.trustedDevice.channel = channel !== null && channel !== void 0 ? channel : draft.trustedDevice.channel;
                draft.trustedDevice.otp = otp !== null && otp !== void 0 ? otp : draft.trustedDevice.otp;
                draft.trustedDevice.target = target !== null && target !== void 0 ? target : draft.trustedDevice.target;
                draft.trustedDevice.remainingSecond = remainingSecond !== null && remainingSecond !== void 0 ? remainingSecond : draft.trustedDevice.remainingSecond;
                draft.trustedDevice.isSubmitting = isSubmitting !== null && isSubmitting !== void 0 ? isSubmitting : draft.trustedDevice.isSubmitting;
                draft.trustedDevice.errorText = errorText !== null && errorText !== void 0 ? errorText : draft.trustedDevice.errorText;
                draft.trustedDevice.errors = errors !== null && errors !== void 0 ? errors : draft.trustedDevice.errors;
            });
        },
        resetTrustedDevice: function() {
            get().updateTrustedDevice(initialState.trustedDevice);
        },
        requestValidateIdentity: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var ktp, dob, bankAccount, mothersName, cb, ref, ref1, token, response, ref2, ref3;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ktp = param.ktp, dob = param.dob, bankAccount = param.bankAccount, mothersName = param.mothersName, cb = param.cb;
                            _ctx.prev = 1;
                            ;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: "",
                                errors: []
                            });
                            token = get().trustedDevice.token;
                            _ctx.next = 7;
                            return requestVerifyIdentity({
                                token: token,
                                identity: ktp,
                                birthDate: dob,
                                bankAccountNumber: bankAccount,
                                motherName: mothersName
                            });
                        case 7:
                            response = _ctx.sent;
                            get().updateTrustedDevice({
                                token: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.token
                            });
                            cb();
                            _ctx.next = 17;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            (0,tracker/* trackerIdentityVerificationFailed */.ey)();
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.cause) === null || ref2 === void 0 ? void 0 : ref2.message,
                                errors: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref3 = _ctx.t0.cause) === null || ref3 === void 0 ? void 0 : ref3.errors
                            });
                        case 17:
                            _ctx.prev = 17;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(17);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        12,
                        17,
                        20
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestValidatePassword: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var password, cb, token, ref;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            password = param.password, cb = param.cb;
                            _ctx.prev = 1;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            token = get().trustedDevice.token;
                            _ctx.next = 6;
                            return requestVerifyPassword({
                                token: token,
                                password: password
                            });
                        case 6:
                            (0,tracker/* trackerInputPasswordSuccess */.gV)();
                            cb();
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message
                            });
                        case 14:
                            _ctx.prev = 14;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(14);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        10,
                        14,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestValidatePin: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var pin, cb, ref, ref1, token, response, ref2;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            pin = param.pin, cb = param.cb;
                            _ctx.prev = 1;
                            ;
                            token = get().trustedDevice.token;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            _ctx.next = 7;
                            return requestVerifyPin({
                                pin: pin,
                                token: token
                            });
                        case 7:
                            response = _ctx.sent;
                            get().updateTrustedDevice({
                                otpRecipients: (0,utils/* mapOtpOptions */.g)(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.otp_recipients)
                            });
                            (0,tracker/* trackerInputPinSuccess */.QE)();
                            cb();
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](1);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.cause) === null || ref2 === void 0 ? void 0 : ref2.message
                            });
                        case 17:
                            _ctx.prev = 17;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(17);
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        13,
                        17,
                        20
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestForgotPIN: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, token, response, ref1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        token = get().trustedDevice.token;
                        get().updateTrustedDevice({
                            isSubmitting: true,
                            errorText: ""
                        });
                        _ctx.next = 6;
                        return requestForgotPin({
                            token: token
                        });
                    case 6:
                        response = _ctx.sent;
                        (0,AlertMessage/* default */.Z)({
                            content: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message,
                            alertType: "snackbar-dark",
                            messageType: "success",
                            hasCloseIcon: false
                        });
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                        });
                    case 14:
                        _ctx.prev = 14;
                        get().updateTrustedDevice({
                            isSubmitting: false
                        });
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    14,
                    17
                ]
            ]);
        })),
        requestOtpTrustedDevice: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, _trustedDevice, token, channel, response, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        get().updateTrustedDevice({
                            isSubmitting: true,
                            errorText: ""
                        });
                        _trustedDevice = get().trustedDevice, token = _trustedDevice.token, channel = _trustedDevice.channel;
                        _ctx.next = 6;
                        return requestOtpTrustedDevice({
                            token: token,
                            channel: channel
                        });
                    case 6:
                        response = _ctx.sent;
                        get().updateTrustedDevice({
                            target: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.target,
                            remainingSecond: (0,utils/* calculateRemainingOtpSecond */.M)(response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.next_attempt_time)
                        });
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.cause) === null || ref4 === void 0 ? void 0 : ref4.message
                        });
                    case 14:
                        _ctx.prev = 14;
                        get().updateTrustedDevice({
                            isSubmitting: false
                        });
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    14,
                    17
                ]
            ]);
        })),
        verifyOtpTrustedDevice: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
                var ref, _trustedDevice, token, otp, response, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            _trustedDevice = get().trustedDevice, token = _trustedDevice.token, otp = _trustedDevice.otp;
                            _ctx.next = 6;
                            return verifyOtpTrustedDevice({
                                token: token,
                                otp: otp
                            });
                        case 6:
                            response = _ctx.sent;
                            store/* store.dispatch */.h.dispatch(credentials/* default.actions.loadCredentialsExodus */.ZP.actions.loadCredentialsExodus(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data));
                            (0,tracker/* trackerLoginCompleted */.pO)();
                            cb();
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                            });
                        case 16:
                            _ctx.prev = 16;
                            get().updateTrustedDevice({
                                isSubmitting: false
                            });
                            return _ctx.finish(16);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12,
                        16,
                        19
                    ]
                ]);
            }));
            return function(cb) {
                return _ref.apply(this, arguments);
            };
        }(),
        requestPromptTrustedDevice: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, ref4, ref5, token, response, ref6;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        get().updateTrustedDevice({
                            isSubmitting: true,
                            errorText: ""
                        });
                        token = get().trustedDevice.token;
                        _ctx.next = 6;
                        return requestSendPrompt({
                            token: token
                        });
                    case 6:
                        response = _ctx.sent;
                        get().updateTrustedDevice({
                            promptToken: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.prompt_token,
                            promptTarget: response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.target,
                            promptRemainingSecond: (0,utils/* calculateRemainingOtpSecond */.M)(response === null || response === void 0 ? void 0 : (ref4 = response.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.next_attempt_time)
                        });
                        _ctx.next = 15;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref6 = _ctx.t0.cause) === null || ref6 === void 0 ? void 0 : ref6.message
                        });
                        throw _ctx.t0;
                    case 15:
                        _ctx.prev = 15;
                        get().updateTrustedDevice({
                            isSubmitting: false
                        });
                        return _ctx.finish(15);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10,
                    15,
                    18
                ]
            ]);
        })),
        getResultPrompTrustedDevice: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, ref2, ref3, promptToken, response, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        promptToken = get().trustedDevice.promptToken;
                        _ctx.next = 5;
                        return getPromptResult(promptToken);
                    case 5:
                        response = _ctx.sent;
                        get().updateTrustedDevice({
                            ackPrompToken: response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.acknowledge_token,
                            promptStatus: response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.status
                        });
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        get().updateTrustedDevice({
                            errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref4 = _ctx.t0.cause) === null || ref4 === void 0 ? void 0 : ref4.message
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        })),
        verifyPromptTrustedDevice: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cb) {
                var ref, _trustedDevice, token, ackPrompToken, response, ref1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            get().updateTrustedDevice({
                                isSubmitting: true,
                                errorText: ""
                            });
                            _trustedDevice = get().trustedDevice, token = _trustedDevice.token, ackPrompToken = _trustedDevice.ackPrompToken;
                            _ctx.next = 6;
                            return verifyPromptRequest({
                                token: token,
                                acknowledgeToken: ackPrompToken
                            });
                        case 6:
                            response = _ctx.sent;
                            store/* store.dispatch */.h.dispatch(credentials/* default.actions.loadCredentialsExodus */.ZP.actions.loadCredentialsExodus(response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.data));
                            (0,tracker/* trackerLoginCompleted */.pO)();
                            cb();
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            get().updateTrustedDevice({
                                errorText: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.cause) === null || ref1 === void 0 ? void 0 : ref1.message
                            });
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(cb) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}), {
    name: "trustedDevice"
}));


/***/ }),

/***/ 33597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ey": function() { return /* binding */ trackerIdentityVerificationFailed; },
  "Wj": function() { return /* binding */ trackerIdentityVerificationStarted; },
  "gV": function() { return /* binding */ trackerInputPasswordSuccess; },
  "QE": function() { return /* binding */ trackerInputPinSuccess; },
  "SU": function() { return /* binding */ trackerLoginAttempt; },
  "pO": function() { return /* binding */ trackerLoginCompleted; },
  "U0": function() { return /* binding */ trackerOtpVerified; },
  "Z3": function() { return /* binding */ trackerPromptSent; }
});

// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
;// CONCATENATED MODULE: ./src/features/trusted-device/constants.ts
var EVENT_NAME = {
    NEW_DEVICE_LOGIN_ATTEMPT: "New Device Login Attempt",
    PROMPT_SENT_TO_TRUSTED_DEVICE: "Prompt Sent To Trusted Device",
    FALLBACK_IDENTITY_VERIFICATION_STARTED: "Fallback Identity Verification Started",
    MANUAL_VERIFICATION_FAILED: "Manual Verification Failed",
    NEW_DEVICE_LOGIN_INPUT_PASSWORD_SUCCESS: "New Device Login Input Password Success",
    NEW_DEVICE_LOGIN_INPUT_PIN_SUCCESS: "New Device Login Input Pin Success",
    NEW_DEVICE_LOGIN_OTP_VERIFIED: "New Device Login Otp Verified",
    NEW_DEVICE_LOGIN_COMPLETED: "New Device Login Completed"
};

;// CONCATENATED MODULE: ./src/features/trusted-device/tracker.ts


var trackerLoginAttempt = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.NEW_DEVICE_LOGIN_ATTEMPT);
};
var trackerPromptSent = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.PROMPT_SENT_TO_TRUSTED_DEVICE);
};
var trackerIdentityVerificationStarted = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.FALLBACK_IDENTITY_VERIFICATION_STARTED);
};
var trackerIdentityVerificationFailed = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.MANUAL_VERIFICATION_FAILED);
};
var trackerInputPasswordSuccess = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.NEW_DEVICE_LOGIN_INPUT_PASSWORD_SUCCESS);
};
var trackerInputPinSuccess = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.NEW_DEVICE_LOGIN_INPUT_PIN_SUCCESS);
};
var trackerOtpVerified = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.NEW_DEVICE_LOGIN_OTP_VERIFIED);
};
var trackerLoginCompleted = function() {
    return (0,clevertap/* clevertapEvent */.Lq)(EVENT_NAME.NEW_DEVICE_LOGIN_COMPLETED);
};


/***/ }),

/***/ 81945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ CHANNEL_OTP; },
/* harmony export */   "g": function() { return /* binding */ PROMPT_STATUS; }
/* harmony export */ });
var CHANNEL_OTP;
(function(CHANNEL_OTP) {
    CHANNEL_OTP["EMAIL"] = "CHANNEL_EMAIL";
    CHANNEL_OTP["SMS"] = "CHANNEL_SMS";
    CHANNEL_OTP["WHATSAPP"] = "CHANNEL_WHATSAPP";
    CHANNEL_OTP["UNSPECIFIED"] = "CHANNEL_UNSPECIFIED";
    CHANNEL_OTP["PROMPT"] = "CHANNEL_PROMPT";
})(CHANNEL_OTP || (CHANNEL_OTP = {}));
var PROMPT_STATUS;
(function(PROMPT_STATUS) {
    PROMPT_STATUS["PROMPT_STATUS_UNSPECIFIED"] = "PROMPT_STATUS_UNSPECIFIED";
    PROMPT_STATUS["PROMPT_STATUS_PENDING"] = "PROMPT_STATUS_PENDING";
    PROMPT_STATUS["PROMPT_STATUS_APPROVED"] = "PROMPT_STATUS_APPROVED";
    PROMPT_STATUS["PROMPT_STATUS_REJECTED"] = "PROMPT_STATUS_REJECTED";
    PROMPT_STATUS["PROMPT_STATUS_EXPIRED"] = "PROMPT_STATUS_EXPIRED";
})(PROMPT_STATUS || (PROMPT_STATUS = {}));


/***/ }),

/***/ 721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ calculateRemainingOtpSecond; },
/* harmony export */   "g": function() { return /* binding */ mapOtpOptions; }
/* harmony export */ });
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81945);

var mapOtpOptions = function(otpRecipients) {
    return otpRecipients === null || otpRecipients === void 0 ? void 0 : otpRecipients.map(function(o) {
        if (o.channel === _types__WEBPACK_IMPORTED_MODULE_0__/* .CHANNEL_OTP.EMAIL */ .U.EMAIL) {
            return {
                value: _types__WEBPACK_IMPORTED_MODULE_0__/* .CHANNEL_OTP.EMAIL */ .U.EMAIL,
                icon: "/icon/password-email-small.svg",
                text: "Send via Email",
                subText: o.target
            };
        }
        if (o.channel === _types__WEBPACK_IMPORTED_MODULE_0__/* .CHANNEL_OTP.WHATSAPP */ .U.WHATSAPP) {
            return {
                value: _types__WEBPACK_IMPORTED_MODULE_0__/* .CHANNEL_OTP.WHATSAPP */ .U.WHATSAPP,
                icon: "/icon/password-whatsapp.svg",
                text: "Send via Whatsapp",
                subText: o.target
            };
        }
        if (o.channel === _types__WEBPACK_IMPORTED_MODULE_0__/* .CHANNEL_OTP.SMS */ .U.SMS) {
            return {
                value: _types__WEBPACK_IMPORTED_MODULE_0__/* .CHANNEL_OTP.SMS */ .U.SMS,
                icon: "/icon/password-message.svg",
                text: "Send via SMS",
                subText: o.target
            };
        }
        return {
            value: _types__WEBPACK_IMPORTED_MODULE_0__/* .CHANNEL_OTP.EMAIL */ .U.EMAIL,
            icon: "/icon/password-email-small.svg",
            text: "Send via Email",
            subText: o.target
        };
    });
};
var calculateRemainingOtpSecond = function(dateTime) {
    if (!dateTime) {
        return 0;
    }
    var givenTime = new Date(dateTime);
    var currentTime = new Date();
    var timeDifference = givenTime.getTime() - currentTime.getTime();
    var remainingSecond = Math.floor(timeDifference / 1000);
    return remainingSecond;
};


/***/ }),

/***/ 54154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ glossaryMetaTags; },
/* harmony export */   "x": function() { return /* binding */ defaultMetaTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);


var defaultMetaTags = {
    title: "Stockbit - Investasi Saham Bersama Komunitas Saham Terbesar di Indonesia",
    description: "Aplikasi saham untuk berdiskusi, analisa dan berinvestasi dengan harga real time, berita terkini, riset, data fundamental, charting, dan analytical tools yang lengkap",
    keywords: "stockbit, investasi, saham, pasar modal, pasar saham, harga saham, belajar investasi, belajar saham, nabung saham, rekomendasi saham, belajar trading, virtual trading, komunitas saham, ihsg, berita saham, analisa saham, jual beli saham, bei, bursa saham indonesia, idx, professional tools, tools saham, saham bumi, reksadana, jkse",
    image: "https://stockbit.com/assets/img/stockbit.jpg",
    url: "https://stockbit.com"
};
var glossaryMetaTags = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, defaultMetaTags), {
    title: "Stockbit Glossary | Stockbit - Kamus Investasi Saham",
    url: "https://stockbit.com/glossary"
});
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 26350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54154);







function SEO(param) {
    var title = param.title, description = param.description, keywords = param.keywords, image = param.image, url = param.url, schemaJson = param.schemaJson, customTitle = param.customTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title && !schemaJson && !customTitle ? "".concat(title, " | ").concat(_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags.title */ .x.title) : title
            }),
            constants_app__WEBPACK_IMPORTED_MODULE_2__/* .isProduction */ .yv ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "revisit-after",
                content: "1 days"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "resource-type",
                content: "document"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "audience",
                content: "general"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "content-language",
                content: "id-ID"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "web_author",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "copyright",
                content: "Stockbit"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google-site-verification",
                content: "n9LVcB1gB0We60y2dG78-koFgM8y_mrf9pw1hrKsxFA"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "fb:app_id",
                content: constants_api__WEBPACK_IMPORTED_MODULE_1__/* .FACEBOOK_APP_ID */ .lZ
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            schemaJson ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(schemaJson)
                }
            }) : null
        ]
    });
}
SEO.defaultProps = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMetaTags */ .x), {
    customTitle: false
});
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 80288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86123);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19225);




/**
 * Hooks to redirect user if they have been logged in
 */ function usePublicProtectedRoute() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var checkCredential = function() {
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken();
        if (localStorage.at && parsedCookie) {
            var token = parsedCookie.accessToken.token;
            return !!token;
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var isLoggedIn = checkCredential();
        setLoggedIn(isLoggedIn);
        if (isLoggedIn && !router.asPath.includes("/stream")) {
            window.location.href = "".concat(window.location.origin).concat(constants_app__WEBPACK_IMPORTED_MODULE_2__/* .PROJECT_FOLDER_PATH */ .qV, "/stream");
        }
    }, [
        router
    ]);
    return loggedIn;
}
/* harmony default export */ __webpack_exports__["Z"] = (usePublicProtectedRoute);


/***/ }),

/***/ 50259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mP": function() { return /* binding */ b; },
/* harmony export */   "pm": function() { return /* binding */ d; },
/* harmony export */   "xX": function() { return /* binding */ m; }
/* harmony export */ });
/* unused harmony exports GoogleReCaptchaConsumer, GoogleReCaptchaContext, withGoogleReCaptcha */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var i=function(){return(i=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e}).apply(this,arguments)};function s(e,t,r,o){return new(r||(r=Promise))((function(n,c){function a(e){try{s(o.next(e))}catch(e){c(e)}}function i(e){try{s(o.throw(e))}catch(e){c(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(a,i)}s((o=o.apply(e,t||[])).next())}))}function u(e,t){var r,o,n,c,a={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return c={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(c[Symbol.iterator]=function(){return this}),c;function i(c){return function(i){return function(c){if(r)throw new TypeError("Generator is already executing.");for(;a;)try{if(r=1,o&&(n=2&c[0]?o.return:c[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,c[1])).done)return n;switch(o=0,n&&(c=[2&c[0],n.value]),c[0]){case 0:case 1:n=c;break;case 4:return a.label++,{value:c[1],done:!1};case 5:a.label++,o=c[1],c=[0];continue;case 7:c=a.ops.pop(),a.trys.pop();continue;default:if(!(n=a.trys,(n=n.length>0&&n[n.length-1])||6!==c[0]&&2!==c[0])){a=0;continue}if(3===c[0]&&(!n||c[1]>n[0]&&c[1]<n[3])){a.label=c[1];break}if(6===c[0]&&a.label<n[1]){a.label=n[1],n=c;break}if(n&&a.label<n[2]){a.label=n[2],a.ops.push(c);break}n[2]&&a.ops.pop(),a.trys.pop();continue}c=t.call(e,a)}catch(e){c=[6,e],o=0}finally{r=n=0}if(5&c[0])throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}([c,i])}}}var f,l=function(e){var t=e.reCaptchaKey,r=e.language,o=e.onLoad,n=e.useRecaptchaNet,c=e.useEnterprise,a=e.scriptProps,i=void 0===a?{}:a,s=i.nonce,u=void 0===s?"":s,f=i.defer,l=void 0!==f&&f,p=i.async,y=void 0!==p&&p,d=i.id,m=void 0===d?"":d,b=i.appendTo,h=void 0===b?void 0:b,v=m||"google-recaptcha-v3";if(function(e){return!!document.querySelector("#"+e)}(v))o();else{var S=function(e){var t=e.useRecaptchaNet,r=e.useEnterprise;return"https://www."+(t&&!r?"recaptcha.net":"google.com")+"/recaptcha/"+(r?"enterprise.js":"api.js")}({useEnterprise:c,useRecaptchaNet:n}),g=document.createElement("script");g.id=v,g.src=S+"?render="+t+(r?"&hl="+r:""),u&&(g.nonce=u),g.defer=!!l,g.async=!!y,g.onload=o,("body"===h?document.body:document.getElementsByTagName("head")[0]).appendChild(g)}};!function(e){e.SCRIPT_NOT_AVAILABLE="Recaptcha script is not available"}(f||(f={}));var p=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({executeRecaptcha:function(){throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider")}}),y=p.Consumer;function d(t){var a=this,i=t.reCaptchaKey,y=t.useEnterprise,d=void 0!==y&&y,m=t.useRecaptchaNet,b=void 0!==m&&m,h=t.scriptProps,v=t.language,S=t.children,g=(0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null),$=g[0],w=g[1];(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((function(){if(i){var e=(null==h?void 0:h.id)||"google-recaptcha-v3";return l({reCaptchaKey:i,useEnterprise:d,useRecaptchaNet:b,scriptProps:h,language:v,onLoad:function(){if(window&&window.grecaptcha){var e=d?window.grecaptcha.enterprise:window.grecaptcha;e.ready((function(){w(e)}))}else console.warn("<GoogleRecaptchaProvider /> "+f.SCRIPT_NOT_AVAILABLE)}}),function(){!function(e){var t=document.querySelector(".grecaptcha-badge");t&&t.parentNode&&document.body.removeChild(t.parentNode);var r=document.querySelector("#"+e);r&&r.remove()}(e)}}console.warn("<GoogleReCaptchaProvider /> recaptcha key not provided")}),[d,b,h,v]);var P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((function(e){return s(a,void 0,void 0,(function(){return u(this,(function(t){switch(t.label){case 0:if(!$||!$.execute)throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");return[4,$.execute(i,{action:e})];case 1:return[2,t.sent()]}}))}))}),[$]),C=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((function(){return{executeRecaptcha:$?P:void 0}}),[P,$]);return react__WEBPACK_IMPORTED_MODULE_0__.createElement(p.Provider,{value:C},S)}var m=function(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(p)};function b(e){var t=this,r=e.action,n=e.onVerify,c=m();return (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((function(){var e=c.executeRecaptcha;s(t,void 0,void 0,(function(){var t;return u(this,(function(o){switch(o.label){case 0:return e?[4,e(r)]:(console.warn("Execute recaptcha function not defined"),[2]);case 1:return t=o.sent(),n?(n(t),[2]):(console.warn("Please define an onVerify function"),[2])}}))}))}),[r,n,c]),null}function h(e,t){return e(t={exports:{}},t.exports),t.exports
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */}var v="function"==typeof Symbol&&Symbol.for,S=v?Symbol.for("react.element"):60103,g=v?Symbol.for("react.portal"):60106,$=v?Symbol.for("react.fragment"):60107,w=v?Symbol.for("react.strict_mode"):60108,P=v?Symbol.for("react.profiler"):60114,C=v?Symbol.for("react.provider"):60109,x=v?Symbol.for("react.context"):60110,E=v?Symbol.for("react.async_mode"):60111,R=v?Symbol.for("react.concurrent_mode"):60111,M=v?Symbol.for("react.forward_ref"):60112,N=v?Symbol.for("react.suspense"):60113,O=v?Symbol.for("react.suspense_list"):60120,T=v?Symbol.for("react.memo"):60115,j=v?Symbol.for("react.lazy"):60116,_=v?Symbol.for("react.block"):60121,F=v?Symbol.for("react.fundamental"):60117,A=v?Symbol.for("react.responder"):60118,L=v?Symbol.for("react.scope"):60119;function k(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case S:switch(e=e.type){case E:case R:case $:case P:case w:case N:return e;default:switch(e=e&&e.$$typeof){case x:case M:case j:case T:case C:return e;default:return t}}case g:return t}}}function G(e){return k(e)===R}var V={AsyncMode:E,ConcurrentMode:R,ContextConsumer:x,ContextProvider:C,Element:S,ForwardRef:M,Fragment:$,Lazy:j,Memo:T,Portal:g,Profiler:P,StrictMode:w,Suspense:N,isAsyncMode:function(e){return G(e)||k(e)===E},isConcurrentMode:G,isContextConsumer:function(e){return k(e)===x},isContextProvider:function(e){return k(e)===C},isElement:function(e){return"object"==typeof e&&null!==e&&e.$$typeof===S},isForwardRef:function(e){return k(e)===M},isFragment:function(e){return k(e)===$},isLazy:function(e){return k(e)===j},isMemo:function(e){return k(e)===T},isPortal:function(e){return k(e)===g},isProfiler:function(e){return k(e)===P},isStrictMode:function(e){return k(e)===w},isSuspense:function(e){return k(e)===N},isValidElementType:function(e){return"string"==typeof e||"function"==typeof e||e===$||e===R||e===P||e===w||e===N||e===O||"object"==typeof e&&null!==e&&(e.$$typeof===j||e.$$typeof===T||e.$$typeof===C||e.$$typeof===x||e.$$typeof===M||e.$$typeof===F||e.$$typeof===A||e.$$typeof===L||e.$$typeof===_)},typeOf:k},z=h((function(e,t){ false&&0})),I=(z.AsyncMode,z.ConcurrentMode,z.ContextConsumer,z.ContextProvider,z.Element,z.ForwardRef,z.Fragment,z.Lazy,z.Memo,z.Portal,z.Profiler,z.StrictMode,z.Suspense,z.isAsyncMode,z.isConcurrentMode,z.isContextConsumer,z.isContextProvider,z.isElement,z.isForwardRef,z.isFragment,z.isLazy,z.isMemo,z.isPortal,z.isProfiler,z.isStrictMode,z.isSuspense,z.isValidElementType,z.typeOf,h((function(e){ true?e.exports=V:0}))),D={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},q={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},B={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},K={};function U(e){return I.isMemo(e)?B:K[e.$$typeof]||D}K[I.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},K[I.Memo]=B;var H=Object.defineProperty,J=Object.getOwnPropertyNames,Q=Object.getOwnPropertySymbols,W=Object.getOwnPropertyDescriptor,X=Object.getPrototypeOf,Y=Object.prototype;var Z=function e(t,r,o){if("string"!=typeof r){if(Y){var n=X(r);n&&n!==Y&&e(t,n,o)}var c=J(r);Q&&(c=c.concat(Q(r)));for(var a=U(t),i=U(r),s=0;s<c.length;++s){var u=c[s];if(!(q[u]||o&&o[u]||i&&i[u]||a&&a[u])){var f=W(r,u);try{H(t,u,f)}catch(e){}}}}return t},ee=function(t){var r=function(r){return e.createElement(y,null,(function(o){return e.createElement(t,i({},r,{googleReCaptchaProps:o}))}))};return r.displayName="withGoogleReCaptcha("+(t.displayName||t.name||"Component")+")",Z(r,t),r};
//# sourceMappingURL=react-google-recaptcha-v3.esm.js.map


/***/ }),

/***/ 42435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ immer; }
/* harmony export */ });
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);


const immerImpl = (initializer) => (set, get, store) => {
  store.setState = (updater, replace, ...a) => {
    const nextState = typeof updater === "function" ? (0,immer__WEBPACK_IMPORTED_MODULE_0__/* .produce */ .Uy)(updater) : updater;
    return set(nextState, replace, ...a);
  };
  return initializer(store.setState, get, store);
};
const immer = immerImpl;




/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [74885,63332,25287,94119,78656,71577,75819,88069,46819,7648,25935,51225,80129,40142,80737,50299,77549,92961,54253,54005,33070,58928,92077,76750,79931,35851,16735,44912,62571,21671,74768,40927,12683,92140,83930,90448,1888,61805,49774,92888,40179], function() { return __webpack_exec__(73700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);